var _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalenderIcon = function SvgCalenderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.353 2.587h-9.06V.984a.985.985 0 0 0-1.97 0v1.603H3.947A2.987 2.987 0 0 0 .96 5.573v15.44A2.987 2.987 0 0 0 3.948 24h18.024a2.987 2.987 0 0 0 2.988-2.987V5.573a2.987 2.987 0 0 0-2.988-2.986h-2.65V.984a.985.985 0 0 0-1.97 0zm5.637 8.83v9.597c0 .562-.456 1.017-1.018 1.017H3.949a1.02 1.02 0 0 1-1.018-1.017v-9.596zm-3.667-6.861v1.153a.985.985 0 0 1-1.97 0V4.556h-9.06v1.153a.985.985 0 0 1-1.97 0V4.556H3.947c-.562 0-1.017.455-1.017 1.017v5.845h20.06V5.573c0-.562-.456-1.017-1.018-1.017z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 4.5,
    x: 6.746,
    y: 9,
    fill: "currentColor",
    rx: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 4.5,
    x: 14.246,
    y: 9,
    fill: "currentColor",
    rx: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 4.5,
    x: 14.246,
    y: 15,
    fill: "currentColor",
    rx: 0.5
  })));
};
export { SvgCalenderIcon as ReactComponent };